import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/web/src/lib/tracking/SendPageTracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/web/src/ui/authorsMosaic/AuthorsMosaic.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/web/src/ui/SectionSeparator/SectionSeparator.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/web/src/ui/authorsPage/AuthorsPageHeader/AuthorsPageHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@silversea-ssc+design-system-icons@3.22.1/node_modules/@silversea-ssc/design-system-icons/dist/svg-sprite.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/.pnpm/react-loading-skeleton@3.5.0_react@19.2.8/node_modules/react-loading-skeleton/dist/index.js");
